import { render, staticRenderFns } from "./reimbursement.vue?vue&type=template&id=228903b1&scoped=true"
import script from "./reimbursement.vue?vue&type=script&lang=js"
export * from "./reimbursement.vue?vue&type=script&lang=js"
import style0 from "./reimbursement.vue?vue&type=style&index=0&id=228903b1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228903b1",
  null
  
)

export default component.exports